import {
	AddProductContainer,
	AddStockContainer,
	EditModalContainer,
	EditStockContainer,
	LinkModalContainer,
	ViewMoreContainer,
	DeleteModalContainer,
	DeleteProductModalContainer,
	AddVariationMainContainer,
	ActivityTrailContainer,
	UpdateQtyContainer,
	ViewMoreStockContainer,
	AddRateCardMainContainer,
	UpdateRateCardMainContainer,
} from '../../containers';
import {
	AppPage,
	BusinessInsightComponent as BIC,
	MimaButton,
	MimaText,
	Modal,
	MimaTable,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { businessStore, inventoryStore, userStore } from '../../stores';
import MimaOptionMenu from '../../components/OptionMenu/';
import { AnimatePresence, motion } from 'framer-motion';
import { downloadXlsx2 } from '../../utils/download';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { amountFormatter } from '../../utils/utils';
import { useMediaQuery } from 'react-responsive';
import React, { useMemo, useState } from 'react';
import moment from 'moment';
import Survey from '../../components/Survey/Survey';
import constant from '../../utils/constant';

const Inventory = ({
	showAddProductModal,
	addProductModal,
	editStockModal,
	closeModal,
	openLinkModal,
	refresh,
	setTableType,
	tableType,
	addStockModal,
	openDeleteModal,
	openViewMoreModal,
	openEditModal,
	openDeleteProductModal,
	handleOptionSelect,
	handleStockOptionSelect,
	showAddVariationModal,
	addVariation,
	filterPeriod,
	activityTrailModal,
	updateQtyModal,
	openViewMoreStock,
	addRateCardModal,
	updateRateCardModal,
	showAddRateCardModal,
	handleRateCardOptionSelect,

	//Product type
	productDataInfo,
	isLoading,
	isFetching,
	onProductLimitChange,
	productLimit,
	productCurrentPage,
	setProductCurrentPage,
	setProductSearchQuery,

	//Stock
	onStockLimitChange,
	stockLimit,
	stockCurrentPage,
	setStockCurrentPage,
	setStockSearchQuery,
	stockDataInfo,
	rateCardInfo,
	onRateCardLimitChange,
	rateCardLimit,
	rateCardCurrentPage,
	setRateCardCurrentPage,
	setRateCardSearchQuery,
	setStockStatus,
}) => {
	const stockSummary = inventoryStore.stockAnalysis.analysis;
	const [showSurvey, setShowSurvey] = useState(false);
	const [curr, setCurr] = useState(
		`${businessStore.defaultCurrency ? businessStore.defaultCurrency : 'NGN'}`
	);
	const [showCurr, setShowCurr] = useState(false);
	const [viewMore, setViewMore] = useState(false);

	const isBelow500 = useMediaQuery({
		query: '(max-width: 500px)',
	});

	const tableData = useMemo(() => {
		if (productDataInfo?.status === constant.Success) {
			return productDataInfo?.data?.value || [];
		}
		return [];
	}, [productDataInfo]);

	const tableColumns = [
		{
			Header: 'Image',
			accessor: 'imageUrls',
			Cell: ({ cell }) => {
				const imgArray = cell.value;
				return imgArray.length > 0 ? (
					<img src={imgArray[0]} alt="Product" />
				) : (
					<span>N/A</span>
				);
			},
		},
		{
			Header: 'Name',
			accessor: 'name',
		},
		{
			Header: 'Stock Counts ',
			accessor: 'stocks',
			Cell: ({ cell }) => {
				const stocksArray = cell.value;
				return stocksArray.length > 0 ? (
					<span>{stocksArray.length}</span>
				) : (
					<span className={styles.lengthColor}>'NO STOCK ADDED'</span>
				);
			},
		},
		{
			Header: 'Measurement Unit',
			accessor: 'unitOfMeasurement',
		},

		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const id = cell.row.original._id;
				const product = cell.row.original;
				return (
					<MimaOptionMenu
						options={[
							{
								value: 'add variation',
								label: 'Add Stock',
							},
							{
								value: 'view more',
								label: 'View More',
							},
							{
								value: 'edit',
								label: 'Edit',
							},
							// {
							// 	value: 'share link',
							// 	label: 'Share Link',
							// },
							{
								value: 'delete',
								label: 'Delete Product Type',
							},
						]}
						onOptionSelected={option => {
							handleOptionSelect(id, product, option);
						}}
					/>
				);
			},
		},
	];

	const stockTableData = useMemo(() => {
		if (stockDataInfo.data?.status === constant.Success) {
			return stockDataInfo.data?.data?.value || [];
		}
		return [];
	}, [stockDataInfo.data]);

	const stockTableColumns = [
		{
			Header: 'Product Type Name',
			accessor: 'name',
			Cell: ({ cell }) => {
				const name = cell.value;
				const stockTitle = cell.row.original.title;
				const productName = name.replace(`-${stockTitle}`, '');
				return <span>{productName}</span>;
			},
		},
		{
			Header: 'Stock Name',
			accessor: 'title',
		},
		{
			Header: 'Stocks',
			accessor: 'variations',
			Cell: ({ cell }) => {
				const variationsArray = cell.value;
				return variationsArray.length > 0 ? (
					<>
						{variationsArray.map((variation, i) => (
							<span key={i}>
								{variation.type}: {variation.value}
							</span>
						))}
					</>
				) : (
					''
				);
			},
		},
		{
			Header: 'Selling Price',
			accessor: 'sellingPrice',
			Cell: ({ cell }) => {
				const sellingPrice = cell.value;
				const currencyCode = cell.row.original.currencyCode;
				const formattedAmount =
					amountFormatter(currencyCode).format(sellingPrice);

				return <span>{formattedAmount}</span>;
			},
		},
		{
			Header: 'Total Quantity',
			accessor: 'quantity',
		},
		{
			Header: 'Status',
			accessor: 'status',
		},
		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const id = cell.row.original._id;
				const stock = cell.row.original;
				return (
					<MimaOptionMenu
						options={[
							{
								value: 'Update Quantity',
								label: 'Update Quantity',
							},
							{
								value: 'Edit Stock',
								label: 'Edit Stock',
							},
							{
								value: 'View More',
								label: 'View More',
							},
							{
								value: 'Delete Stock',
								label: 'Delete Stock',
							},
							{
								value: 'Activity Trail',
								label: 'Activity Trail',
							},
						]}
						onOptionSelected={option => {
							handleStockOptionSelect(id, stock, option);
						}}
					/>
				);
			},
		},
	];
	const inactiveStockTableColumns = [
		{
			Header: 'Product Type Name',
			accessor: 'name',
			Cell: ({ cell }) => {
				const name = cell.value;
				const stockTitle = cell.row.original.title;
				const productName = name.replace(`-${stockTitle}`, '');
				return <span>{productName}</span>;
			},
		},
		{
			Header: 'Stock Name',
			accessor: 'title',
		},
		{
			Header: 'Stocks',
			accessor: 'variations',
			Cell: ({ cell }) => {
				const variationsArray = cell.value;
				return variationsArray.length > 0 ? (
					<>
						{variationsArray.map((variation, i) => (
							<span key={i}>
								{variation.type}: {variation.value}
							</span>
						))}
					</>
				) : (
					''
				);
			},
		},
		{
			Header: 'Selling Price',
			accessor: 'sellingPrice',
			Cell: ({ cell }) => {
				const sellingPrice = cell.value;
				const currencyCode = cell.row.original.currencyCode;
				const formattedAmount =
					amountFormatter(currencyCode).format(sellingPrice);

				return <span>{formattedAmount}</span>;
			},
		},
		{
			Header: 'Total Quantity',
			accessor: 'quantity',
		},
		{
			Header: 'Status',
			accessor: 'status',
		},
	];

	const rateCardTableData = useMemo(() => {
		if (rateCardInfo.data?.status === constant.Success) {
			return rateCardInfo.data?.data?.value || [];
		}
		return [];
	}, [rateCardInfo]);

	const rateCardTableColumns = [
		{
			Header: 'Grade',
			accessor: 'grade',
		},
		{
			Header: 'Title',
			accessor: 'title',
		},
		{
			Header: 'Selling Price',
			accessor: 'sellingPrice',
			Cell: ({ cell }) => {
				const sellingPrice = cell.value;
				const formattedAmount = amountFormatter().format(sellingPrice);
				return <span>{formattedAmount}</span>;
			},
		},
		{
			Header: 'Split Percentage',
			accessor: 'splitPercentage',
		},
		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const id = cell.row.original._id;
				const rateCard = cell.row.original;
				return (
					<MimaOptionMenu
						options={[
							{
								value: 'Update Rate Card',
								label: 'Update Rate Card',
							},
						]}
						onOptionSelected={option => {
							handleRateCardOptionSelect(id, rateCard, option);
						}}
					/>
				);
			},
		},
	];

	const printProductData = tableData?.map(product => ({
		'Date Added': moment(product.createdAt).format('DD/MM/YYY HH:mm a'),
		'Product Type Name': product.name,
		Description: product.description,
		'Stock Counts': product.stocks?.length || 'NO STOCK ADDED',
		'Measurement Unit': product.unitOfMeasurement,
		'Has split payment': product?.hasSplit === true ? 'True' : 'False',
		'Has Stock': product.noVariation === true ? 'False' : 'True',
		'Bank': product.split?.bank || '',
		'Account Name': product.split?.accountName || '',
		'Account Number': product.split?.accountNumber || '',
	}));

	const printRateCardData = rateCardTableData?.map(rate => ({
		Created: moment(rate.createdAt).format('DD/MM/YYY HH:mm a'),
		Title: rate.title,
		Grade: rate.grade,
		'Selling Price': amountFormatter().format(rate.sellingPrice),
		'Split Percentage': rate.splitPercentage,
	}));

	const printStockData = stockTableData?.map(stock => {
		const costPriceFields = [];
		const quantityFields = [];
		const totalCostPriceFields = [];
		const costValues = {};

		for (let i = 0; i < stock.quantityTracker.length; i++) {
			const costPrice = stock.quantityTracker[i]?.costPrice || 0;
			const quantity = stock.quantityTracker[i]?.quantity || 0;

			costPriceFields.push(`Cost Price ${i + 1}`);
			quantityFields.push(`Cost Price ${i + 1} Quantity`);
			totalCostPriceFields.push(`Total Cost Price ${i + 1}`);

			costValues[`Cost Price ${i + 1}`] = costPrice;
			costValues[`Cost Price ${i + 1} Quantity`] = quantity;
			costValues[`Total Cost Price ${i + 1}`] = costPrice * quantity;
		}

		return {
			'Date Added': moment(stock.createdAt).format('DD/MM/YYYY HH:mm a'),
			'Product Type Name': stock?.product?.name || '',
			'Stock Name': stock?.title,
			Status: stock.status,
			'Total Quantity': stock.quantity,
			'Stock condition': stock.productCondition,
			Currency: stock.currencyCode,
			'Selling Price': amountFormatter(stock.currencyCode).format(
				stock.sellingPrice
			),
			Discount: amountFormatter(stock.currencyCode).format(
				stock.discountAmount
			),
			'Shipping Fee': amountFormatter(stock.currencyCode).format(
				stock.shippingFee
			),
			...costValues,
		};
	});

	return (
		<AppPage pageTitle="Stock" refresh={refresh}>
			<MimaText variant="subtitle" mb={2} align="center">
				You are viewing {filterPeriod} Stock Insights
			</MimaText>

			<div className={styles.main__metrics_container}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						marginBottom: '1rem',
					}}>
					<MimaText color="var(--color-primary-4)" mb={1} width={30}>
						Stock Analysis for{' '}
						{stockSummary?.length === 0 ? filterPeriod : curr}
					</MimaText>

					{stockSummary?.length > 1 ? (
						<div className={styles.selectCurrency__text}>
							<MimaText
								variant="small"
								color="var(--color-primary-4)"
								style={{ paddingTop: '.5rem' }}
								width={12}>
								Click arrow for other currencies
							</MimaText>

							<div className={styles.selectCurrency}>
								<div
									className={
										!showCurr
											? styles.selectCurrency__icon
											: styles.selectCurrency__icon_active
									}
									onClick={() => {
										setShowCurr(!showCurr);
									}}>
									<MdKeyboardArrowDown />
								</div>

								<AnimatePresence>
									{showCurr && (
										<motion.div
											initial={{
												opacity: 0,
												scaleY: 0,
											}}
											animate={{
												scaleY: 1,
												opacity: 1,
												transition: {
													duration: 0.2,
												},
											}}
											exit={{
												scaleY: 0,
												opacity: 0,
												transition: {
													duration: 0.2,
												},
											}}
											style={{ originY: 0 }}
											className={styles.selectCurrency__list}>
											{stockSummary.map(item => (
												<li
													key={item._id}
													className={
														curr === item._id
															? styles.selectCurrency__list_active
															: ''
													}
													onClick={() => {
														setCurr(item._id);
														setShowCurr(false);
													}}>
													{item._id}
												</li>
											))}
										</motion.div>
									)}
								</AnimatePresence>
							</div>
						</div>
					) : (
						''
					)}
				</div>
				<div className={styles.main__metrics}>
					<BIC
						title="Product Types"
						amount={inventoryStore.stockAnalysis?.totalProduct || 0}
						styleClass={styles.main__metrics_lightBlue}
					/>
					{stockSummary
						?.filter(x => {
							return x._id === curr;
						})
						.map((stockAnalysis, i) => (
							<React.Fragment key={i}>
								<BIC
									title="Stock Counts"
									amount={stockAnalysis?.stockCount || 0}
									styleClass={styles.main__metrics_grey}
								/>
								<BIC
									title="Total Stock(Variation) Value"
									amount={amountFormatter(stockAnalysis?._id).format(
										stockAnalysis?.totalSellingPrice || 0
									)}
									styleClass={styles.main__metrics_lightBlue2}
								/>

								<BIC
									title="Items Low On Stock"
									amount={stockAnalysis?.lowStockCount || 0}
									styleClass={styles.main__metrics_red}
								/>
							</React.Fragment>
						))}

					{viewMore && (
						<>
							{stockSummary
								?.filter(x => {
									return x._id === curr;
								})
								.map((stockAnalysis, i) => (
									<React.Fragment key={i}>
										<BIC
											title="Total Cost Price"
											amount={amountFormatter(stockAnalysis?._id).format(
												stockAnalysis?.totalCostPrice || 0
											)}
											styleClass={styles.main__metrics_grey}
										/>
										<BIC
											title="Total Selling Price"
											amount={amountFormatter(stockAnalysis?._id).format(
												stockAnalysis?.totalSellingPrice || 0
											)}
											styleClass={styles.main__metrics_lightBlue2}
										/>

										<BIC
											title="Total Stock Profit Margin"
											amount={amountFormatter(stockAnalysis?._id).format(
												stockAnalysis?.expectedProfit || 0
											)}
											styleClass={styles.main__metrics_red}
										/>
									</React.Fragment>
								))}
						</>
					)}
				</div>

				<div style={{ display: 'flex', justifyContent: 'end' }}>
					<MimaButton
						variant="text"
						title={viewMore ? 'View Less' : 'View More'}
						onClick={() => {
							setViewMore(!viewMore);
						}}
					/>
				</div>
			</div>

			<div className={styles.middleButtons}>
				<MimaButton
					title="Add Product Type"
					onClick={showAddProductModal}
					width={isBelow500 ? 38 : 28}
				/>

				<MimaButton
					title="Add Stock"
					onClick={showAddVariationModal}
					width={isBelow500 ? 38 : 27}
					buttonColor="var(--color-dark)"
				/>
				<MimaButton
					title="Add Rate Card"
					onClick={showAddRateCardModal}
					width={isBelow500 ? 38 : 27}
				/>
			</div>

			<MimaText mt={6} variant="bodyBold" align="center">
				You are viewing {tableType} Table
			</MimaText>
			<div className={styles.main_nav}>
				<div
					className={
						tableType === 'Product Type'
							? styles.main_nav_item_active
							: styles.main_nav_item
					}
					onClick={() => {
						setStockStatus('');
						setTableType('Product Type');
					}}>
					Product Type Table
				</div>
				<div
					className={
						tableType === 'Stock'
							? styles.main_nav_item_active
							: styles.main_nav_item
					}
					onClick={() => {
						setStockStatus('');
						setTableType('Stock');
					}}>
					Stock Table
				</div>
				<div
					className={
						tableType === 'Inactive Stock'
							? styles.main_nav_item_active
							: styles.main_nav_item
					}
					onClick={() => {
						setStockStatus('INACTIVE');
						setTableType('Inactive Stock');
					}}>
					Inactive Stock Table
				</div>
				<div
					className={
						tableType === 'Rate Card'
							? styles.main_nav_item_active
							: styles.main_nav_item
					}
					onClick={() => {
						setStockStatus('');
						setTableType('Rate Card');
					}}>
					Rate Cards
				</div>
			</div>
			<div>
				{tableType === 'Product Type' && (
					<MimaButton
						variant="text"
						title="Download Inventory Report"
						onClick={() => {
							downloadXlsx2(printProductData, `Product Type Report`);
						}}
					/>
				)}

				{tableType === 'Rate Card' && (
					<MimaButton
						variant="text"
						title="Download Rate Card Report"
						onClick={() => {
							downloadXlsx2(printRateCardData, `Rate Card`);
						}}
					/>
				)}

				{tableType === 'Stock' && (
					<MimaButton
						variant="text"
						title="Download Stock Report"
						onClick={() => {
							downloadXlsx2(printStockData, `Stock Report`);
						}}
					/>
				)}
				{tableType === 'Inactive Stock' && (
					<MimaButton
						variant="text"
						title="Download Inactive Stock Report"
						onClick={() => {
							downloadXlsx2(printStockData, `Inactive Stock Report`);
						}}
					/>
				)}
			</div>

			{tableType === 'Product Type' && (
				<MimaTable
					tableData={tableData}
					tableColumns={tableColumns}
					searchPlaceholder="Search Product Type"
					searchVariant="wide"
					totalItems={productDataInfo?.data?.totalCounts}
					onLimitChange={onProductLimitChange}
					isLoading={isLoading}
					isFetching={isFetching}
					limit={productLimit}
					currentPage={productCurrentPage}
					setCurrentPage={setProductCurrentPage}
					setSearchQuery={setProductSearchQuery}
				/>
			)}

			{tableType === 'Stock' && (
				<MimaTable
					tableData={stockTableData}
					tableColumns={stockTableColumns}
					searchPlaceholder="Search stock"
					searchVariant="wide"
					totalItems={stockDataInfo?.data?.data?.totalCounts}
					onLimitChange={onStockLimitChange}
					isLoading={stockDataInfo?.isLoading}
					isFetching={stockDataInfo?.isFetching}
					limit={stockLimit}
					currentPage={stockCurrentPage}
					setCurrentPage={setStockCurrentPage}
					setSearchQuery={setStockSearchQuery}
				/>
			)}
			{tableType === 'Inactive Stock' && (
				<MimaTable
					tableData={stockTableData}
					tableColumns={inactiveStockTableColumns}
					searchPlaceholder="Search inactive stock"
					searchVariant="wide"
					totalItems={stockDataInfo?.data?.data?.totalCounts}
					onLimitChange={onStockLimitChange}
					isLoading={stockDataInfo?.isLoading}
					isFetching={stockDataInfo?.isFetching}
					limit={stockLimit}
					currentPage={stockCurrentPage}
					setCurrentPage={setStockCurrentPage}
					setSearchQuery={setStockSearchQuery}
				/>
			)}

			{tableType === 'Rate Card' && (
				<MimaTable
					tableData={rateCardTableData}
					tableColumns={rateCardTableColumns}
					searchPlaceholder="Search Rate Card"
					searchVariant="wide"
					totalItems={rateCardInfo?.data?.data?.totalCounts}
					onLimitChange={onRateCardLimitChange}
					isLoading={rateCardInfo?.isLoading}
					isFetching={rateCardInfo?.isFetching}
					limit={rateCardLimit}
					currentPage={rateCardCurrentPage}
					setCurrentPage={setRateCardCurrentPage}
					setSearchQuery={setRateCardSearchQuery}
				/>
			)}

			{(addStockModal ||
				openViewMoreModal ||
				openDeleteModal ||
				openEditModal ||
				addProductModal ||
				editStockModal ||
				openDeleteProductModal ||
				openLinkModal ||
				addVariation ||
				addRateCardModal ||
				updateRateCardModal ||
				activityTrailModal ||
				updateQtyModal ||
				openViewMoreStock ||
				showSurvey) && (
				<div className="modal">
					<AnimatePresence>
						{addProductModal && (
							<AddProductContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{editStockModal && (
							<EditStockContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{openEditModal && (
							<Modal closeModal={closeModal} goBack={closeModal}>
								<EditModalContainer
									closeModal={closeModal}
									setShowSurvey={setShowSurvey}
								/>
							</Modal>
						)}
						{addStockModal && (
							<AddStockContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{addVariation && (
							<AddVariationMainContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{addRateCardModal && (
							<AddRateCardMainContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{updateRateCardModal && (
							<UpdateRateCardMainContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{openLinkModal && <LinkModalContainer closeModal={closeModal} />}
						{openViewMoreModal && <ViewMoreContainer closeModal={closeModal} />}
						{openDeleteModal && (
							<DeleteModalContainer closeModal={closeModal} />
						)}
						{openDeleteProductModal && (
							<DeleteProductModalContainer closeModal={closeModal} />
						)}
						{activityTrailModal && (
							<ActivityTrailContainer closeModal={closeModal} />
						)}
						{updateQtyModal && (
							<UpdateQtyContainer
								closeModal={closeModal}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{openViewMoreStock && (
							<ViewMoreStockContainer closeModal={closeModal} />
						)}
						{showSurvey && (
							<Survey
								title=""
								reviewId={userStore.reviewId}
								closeModal={() => {
									setShowSurvey(false);
								}}
							/>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Inventory;
